import React from 'react';
import { Warning } from '@mui/icons-material';
import { Card, Grid, styled } from '@mui/material';
import { IPayMethod } from 'models';
import { verifyBankAccountMandate } from 'api/PaymentInformationApi';
import { useUserContext } from 'UserContext';
import { useStripe } from '@stripe/react-stripe-js';
import { consoleLogInDev } from 'shared';
import { Colors, PrimaryButton, TandemLink, Text } from 'library';
import PayMethod from 'parent-portal/payments/Components/PayMethod';

export default function PayMethodMandates({
    neededMandates,
    refresh,
}: {
    neededMandates: IPayMethod[];
    refresh: () => void;
}) {
    const { user } = useUserContext();
    const stripeHook = useStripe();

    function onVerifyClick(payMethod: IPayMethod) {
        const customer_id = user?.customer_id;
        verifyBankAccountMandate(stripeHook, payMethod.id, customer_id).then(refresh).catch(consoleLogInDev);
    }

    return (
        <StyledCard>
            <Grid style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <Warning style={{ color: Colors.mediumRed, fontSize: 20 }} />
                <Text variant="body1" bold textStyle={{ color: Colors.mediumRed }}>
                    Action Required: Consent Needed
                </Text>
            </Grid>
            <Text variant="body2" textStyle={{ marginBottom: 8 }}>
                Re-authorize the following bank accounts by <b>May 15</b> to avoid disruption. After this date, payments
                will fail and shift posting will be disabled. You can remove old or unused accounts on the
                <TandemLink style={{ fontSize: 14, textDecoration: 'underline' }} to="/payments">
                    payments page
                </TandemLink>
                .
            </Text>
            {neededMandates.map((x) => (
                <MandateRow key={x.id} container direction="row">
                    <PayMethod payMethod={x} />
                    <PrimaryButton
                        onClick={() => onVerifyClick(x)}
                        buttonStyle={{ width: 'fit-content', backgroundColor: Colors.mediumRed }}
                    >
                        Agree & Consent
                    </PrimaryButton>
                </MandateRow>
            ))}
        </StyledCard>
    );
}

const StyledCard = styled(Card)({
    backgroundColor: Colors.lightRed,
    border: `1px solid ${Colors.mediumRed}`,
    borderRadius: 10,
    padding: 20,
    marginTop: 15,
});

const MandateRow = styled(Grid)({
    margin: '10px 0',
    alignItems: 'center',
    justifyContent: 'space-between',
});
